import { Box } from '@mui/material';
import React from 'react';
/**
 * Renders a vertical divider box with optional right or left margin,
 * useful for visually separating elements in a horizontal layout.
 *
 * @param {object} root0 - Component props.
 * @param {boolean} [root0.right] - If true, applies left margin (default aligns divider to the right side).
 * @param {boolean} root0.smallDevice - Whether the current device is considered small (affects spacing).
 *
 * @returns {JSX.Element} A styled Box component acting as a vertical divider.
 */
export const Divider = ({ right, smallDevice }) => (React.createElement(Box, { sx: {
        width: 0,
        height: 32,
        borderLeftWidth: 1,
        borderLeftStyle: 'solid',
        borderLeftColor: 'grey.700',
        ml: right ? (smallDevice ? 1 : 1) : 0,
        mr: right ? 0 : smallDevice ? 1 : 1,
    } }));
